import _TextField from "@material-ui/core/esm/TextField";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Notification } from 'swag-client-common/components/inputs/notification';
import classes from './text-field.scss';
const textFieldClasses = {
  root: classes.textField
};
const TextField = _ref => {
  let {
      meta,
      input
    } = _ref,
    rest = _objectWithoutProperties(_ref, ["meta", "input"]);
  const {
    active,
    touched,
    error,
    warning
  } = meta;
  const hasError = !!error && touched;
  const showNotification = touched && !active;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_TextField, _extends({
    error: hasError,
    classes: textFieldClasses
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    onChange: rest.onChange || input.onChange
  }, input, rest)), /*#__PURE__*/React.createElement(Notification, {
    error: error,
    warning: warning,
    showNotification: showNotification
  }));
};
export default TextField;